import { Header } from "../components";
import * as components from "../sections";

import styles from "./styles/products.module.scss";

export default function () {
  return (
    <>
      {components.LayoutWrapper(
        <>
          <div className={styles.wrapper}>
            {Header()}
            {components.ProductsSection()}
          </div>
        </>
      )}
    </>
  );
}
